import { Suspense, type ReactNode } from "react";
import { LoadingComponent } from "@gui/widgets/LoadingComponent";
import { SectionErrorBoundary } from "./SectionErrorBoundary";

/**
 * The routed area's boundary, plus the `Suspense` its lazy pages load under. A page that
 * crashes leaves the toolbar and navigation working; navigating away clears the fallback. The
 * root boundary in `main.tsx` now only sees crashes outside the routed area.
 */
export function PageErrorBoundary({ children }: { children: ReactNode }) {
	return (
		<SectionErrorBoundary section="page" resetOnNavigate>
			<Suspense fallback={<LoadingComponent />}>{children}</Suspense>
		</SectionErrorBoundary>
	);
}
